import Icon from '@ant-design/icons';

const Svg = () => (
  <svg viewBox='0 0 20 18' width='1em' height='1em' fill='currentColor'>
    <path d='M18 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V2C20 0.9 19.1 0 18 0ZM18 16H2V2H18V16Z' />
    <path d='M17.41 7.42L15.99 6L12.82 9.17L11.41 7.75L10 9.16L12.82 12L17.41 7.42Z' />
    <path d='M8 4H3V6H8V4Z' />
    <path d='M8 8H3V10H8V8Z' />
    <path d='M8 12H3V14H8V12Z' />
  </svg>
);

export const PlansStepIcon = (props) => {
  return (
    <Icon component={Svg} {...props} />
  );
};